// extracted by mini-css-extract-plugin
export default {"wrapper":"EditUserNameModal_wrapper__OH9P4","title":"EditUserNameModal_title__rI3ac","description":"EditUserNameModal_description__LCLni","shine":"EditUserNameModal_shine__HD7S-"};